import React from 'react';

import { css } from '@emotion/css';
import { Form, FormItemProps } from 'antd';

export type InputValidationProps = {
  validate?: () => boolean | string | undefined;
  children: React.ReactNode;
} & FormItemProps;

export function InputValidation({ validate, children }: InputValidationProps) {
  const validationResult = validate?.();

  return (
    <Form.Item
      help={validationResult !== true ? validationResult : undefined}
      validateStatus={validationResult !== true ? 'error' : undefined}
      validateTrigger="onChange"
      className={css`
        margin-bottom: 0px;
      `}
    >
      {children}
    </Form.Item>
  );
}
